import React from "react";
import { Button } from "@/components/ui/button";
import { useI18nStore } from "@/lib/i18n";
import { Globe } from "lucide-react";
export function LanguageToggle() {
  const lang = useI18nStore((s) => s.lang);
  const setLang = useI18nStore((s) => s.setLang);
  const toggle = () => setLang(lang === 'en' ? 'vi' : 'en');
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      className="gap-2 font-medium hover:bg-accent/50 transition-colors"
    >
      <Globe className="h-4 w-4" />
      <span className="uppercase">{lang}</span>
    </Button>
  );
}